/* eslint-disable no-undef */
import { MenuManager } from './component/front/front-helpers/MenuManager'

document.addEventListener('DOMContentLoaded', e => {
  MenuManager()
  goToAchievementPage()
})

/**
 * Go to achievement page by h2 click
 * @param {event} e
 */
const goToAchievementPage = e => {
  document.addEventListener('click', e => {
    if (e.target && e.target.classList.contains('achievement-title')) {
      window.location.href = e.target.dataset.target
    }
  })
}
